module.exports = __webpack_public_path__ + "img/2.cc568849.jpg";